/* eslint-disable */
/* ---------- CONTACT — form + cal.com booking + ASCII accent ---------- */

import React, { useState as _useStateC } from 'react';
import { Reveal } from './components.jsx';

/* small ASCII map for the side rail */
const CONTACT_ASCII = `   ┌─────────────────────────┐
   │  ▣ inbound.queue        │
   │  ▣ scheduler.cal        │
   │  ▣ briefcase.notion     │
   │  ▢ phone.directvm       │
   │                         │
   │  ► ROUTE: kevin@yyz     │
   │  ► SLA:   <24h business │
   │  ► TZ:    EST (UTC-5)   │
   └─────────────────────────┘`;

function Contact() {
  const [form, setForm] = _useStateC({ name: "", email: "", company: "", topic: "consulting", msg: "" });
  const [sent, setSent] = _useStateC(false);
  const [pong, setPong] = _useStateC(false);
  const [loading, setLoading] = _useStateC(false);
  const [submitError, setSubmitError] = _useStateC("");

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || loading) return;
    setSubmitError("");
    setLoading(true);
    setPong(true);
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          company: form.company,
          topic: form.topic,
          msg: form.msg,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msgs = {
          name_required: "Name is required.",
          invalid_email: "Check that email address.",
          message_too_short: "Message needs at least 10 characters.",
          rate_limited: "Too many submissions — try again in a few minutes.",
          send_failed: "Delivery failed. Try hi@kevinz.ai directly.",
        };
        setSubmitError(msgs[data.error] ?? "Something went wrong. Try hi@kevinz.ai.");
        setPong(false);
        setLoading(false);
        return;
      }
      setTimeout(() => setSent(true), 700);
    } catch (_) {
      setSubmitError("Network error. Try hi@kevinz.ai directly.");
      setPong(false);
      setLoading(false);
    }
  };

  return (
    <section id="contact" data-section="contact" className="section-pad">
      <div className="container">
        <div className="box-head">
          <span>// 14 — contact / book a call</span>
          <span className="rule" />
        </div>

        <Reveal>
          <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 0, border: "1px solid var(--line-strong)", background: "var(--bg-1)" }} className="contact-grid">
            {/* LEFT — form */}
            <div style={{ padding: 36, borderRight: "1px solid var(--line)" }} className="contact-left">
              <div className="prompt-line" style={{ marginBottom: 14 }}>
                <span className="ps">kevin@toronto</span>
                <span className="dim">:</span>
                <span className="amber">~/inbox</span>
                <span className="dim"> $ </span>
                <span>compose --new<span className="cursor" /></span>
              </div>
              <h2 className="h-section" style={{ margin: "0 0 12px" }}>send a ping.</h2>
              <p className="lede" style={{ marginTop: 0 }}>
                Consulting, partnerships, podcast invites, or a hello. I read every message — typically reply within 24h.
              </p>

              {!sent ? (
                <form onSubmit={submit} className="contact-form" style={{ display: "grid", gap: 12, marginTop: 24, maxWidth: 520 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <input className="news-input" type="text" placeholder="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required aria-label="Your name" />
                    <input className="news-input" type="email" placeholder="you@operator.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required aria-label="Email address" />
                  </div>
                  <input className="news-input" type="text" placeholder="company / role (optional)" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} aria-label="Company or role (optional)" />
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--fg-3)" }}>
                    {[
                      { v: "consulting", l: "consulting" },
                      { v: "speaking", l: "speaking" },
                      { v: "press", l: "press" },
                      { v: "other", l: "other" }
                    ].map((o) => (
                      <button key={o.v} type="button" onClick={() => setForm({ ...form, topic: o.v })}
                        style={{
                          padding: "8px 12px",
                          border: "1px solid " + (form.topic === o.v ? "var(--amber)" : "var(--line-strong)"),
                          background: form.topic === o.v ? "color-mix(in oklch, var(--amber) 10%, transparent)" : "transparent",
                          color: form.topic === o.v ? "var(--amber)" : "var(--fg-3)",
                          fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase",
                          cursor: "pointer", transition: "all 140ms ease"
                        }}>
                        ▸ {o.l}
                      </button>
                    ))}
                  </div>
                  <textarea
                    className="news-input"
                    rows={5}
                    placeholder="what are you trying to build?"
                    value={form.msg}
                    onChange={(e) => setForm({ ...form, msg: e.target.value })}
                    required
                    style={{ resize: "vertical", fontFamily: "var(--mono)" }}
                    aria-label="Message"
                  />
                  {submitError && (
                    <div style={{ fontSize: 12, color: "var(--red)", letterSpacing: "0.08em", padding: "8px 0" }}>
                      ▸ {submitError}
                    </div>
                  )}
                  <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                    <button
                      className={"btn btn-primary" + (pong ? " pong-flash" : "")}
                      type="submit"
                      disabled={loading}
                      style={{ position: "relative", opacity: loading ? 0.6 : 1, cursor: loading ? "wait" : "pointer" }}
                    >
                      {pong ? "▸ PONG!" : "▸ SEND PING"}
                    </button>
                    <a className="btn" href="mailto:hi@kevinz.ai?subject=20-min%20intro%20request" style={{ textDecoration: "none" }}>
                      {"$ book 20-min intro →"}
                    </a>
                    <span className="dim" style={{ fontSize: 11, letterSpacing: "0.12em" }}>or email <a href="mailto:hi@kevinz.ai" style={{ color: "var(--amber)" }}>hi@kevinz.ai</a></span>
                  </div>
                </form>
              ) : (
                <div style={{ marginTop: 24, padding: 22, border: "1px solid var(--green)", background: "color-mix(in oklch, var(--green) 6%, transparent)", color: "var(--fg)" }}>
                  <div style={{ fontSize: 11, color: "var(--green)", letterSpacing: "0.22em", textTransform: "uppercase", marginBottom: 8 }}>▸ TRANSMIT_OK · queued</div>
                  <div style={{ fontSize: 14 }}>Got it. I'll route this to my inbox and reply within 24h business.</div>
                  <div className="dim mt-12" style={{ fontSize: 11, letterSpacing: "0.12em" }}>$ ack — payload: {form.topic} from {form.email}</div>
                </div>
              )}

              {/* cal.com embed removed — account not active; booking via email */}
            </div>

            {/* RIGHT — meta + ascii */}
            <div style={{ padding: 36, display: "flex", flexDirection: "column", gap: 22 }} className="contact-right">
              <div>
                <div className="dim" style={{ fontSize: 10, letterSpacing: "0.22em", textTransform: "uppercase", marginBottom: 10 }}>▸ routing table</div>
                <pre style={{ fontFamily: "var(--mono)", fontSize: 11, lineHeight: 1.45, color: "var(--fg-2)", margin: 0, whiteSpace: "pre" }}>{CONTACT_ASCII}</pre>
              </div>

              <div style={{ borderTop: "1px solid var(--line)", paddingTop: 22 }}>
                <div className="dim" style={{ fontSize: 10, letterSpacing: "0.22em", textTransform: "uppercase", marginBottom: 14 }}>▸ social channels</div>
                <div style={{ display: "grid", gap: 10 }}>
                  {[
                    { k: "X / @KZic", v: "https://x.com/KZic", note: "building in public · daily" },
                    { k: "LinkedIn", v: "https://linkedin.com/in/kzicherman", note: "28K+ · CEOs / operators" },
                    { k: "GitHub", v: "https://github.com/KevinZai", note: "31 repos · OSS Commander" },
                    { k: "Discord", v: "https://discord.gg/commander", note: "Insider tier · members" }
                  ].map((s) => (
                    <a key={s.k} href={s.v} target="_blank" rel="noreferrer"
                      style={{ display: "grid", gridTemplateColumns: "120px 1fr auto", gap: 12, padding: "10px 12px", border: "1px solid var(--line)", background: "var(--bg-2)", alignItems: "center", transition: "all 140ms ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "var(--amber)"; e.currentTarget.style.background = "color-mix(in oklch, var(--amber) 5%, var(--bg-2))"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--line)"; e.currentTarget.style.background = "var(--bg-2)"; }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: "var(--fg)" }}>{s.k}</span>
                      <span style={{ fontSize: 11, color: "var(--fg-3)", letterSpacing: "0.04em" }}>{s.note}</span>
                      <span style={{ color: "var(--fg-4)", fontSize: 14 }}>↗</span>
                    </a>
                  ))}
                </div>
              </div>

              {/* PGP block removed 2026-04-27 — fingerprint was placeholder + /.well-known/pgp.txt was a 404.
                  Re-enable when real PGP key is published: drop key file at public/.well-known/pgp.txt
                  and replace fingerprint below with the real one. */}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

Object.assign(window, { Contact });

export { Contact };
